import React from "react";
import ClientConfigurationHelper from "../configuration/ClientConfigurationHelper";
import CoreIcon from "./CoreIcon";

const Bag = props => {
    const {dependency_root} = ClientConfigurationHelper.getGlobalConfiguration();
    const imgSrc = dependency_root+"static/images/bag.png";
    return <CoreIcon imgSrc={imgSrc} {...props}/>
}

export default Bag;